import React, { Component } from 'react';
import TEXT from '../../../../../data/text.json';
import { validateFields, getValidationMessage } from '../../formValidator';

function capsFirst(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

const arrayFields = ['images', 'relatedItems'];

export default class FormController extends Component {
  constructor(props, fieldNames, requiredFields, pages) {
    super(props);

    this.pages = pages;
    // Store field name config
    this.fieldNames = fieldNames;

    if (!requiredFields) {
      this.requiredFields = fieldNames;
    } else {
      this.requiredFields = requiredFields;
    }

    // Set state
    if (props.recoveryState) {
      this.state = props.recoveryState;
    } else {
      this.state = {
        // Form defaults to invalid
        formValid: false,

        stage: 1,

        // Create inital value for all form fields
        ...fieldNames.reduce(
          (result, fieldName) =>
            // The images field is an array not a string
            arrayFields.includes(fieldName)
              ? Object.assign(result, { [fieldName]: [] })
              : Object.assign(result, { [fieldName]: '' }),
          {},
        ),
      };
    }

    // Create field update listeners
    fieldNames.forEach(fieldName => {
      this[`set${capsFirst(fieldName)}`] = arrayFields.includes(fieldName)
        ? images => this.updateValue(fieldName, images)
        : event => this.updateValue(fieldName, event.target.value);
    });
  }

  updateValue = (property, value) => {
    this.setState(state => ({ [property]: value }));
    this.setState(state => ({ formValid: this.validate(state) }));
  };

  validate = state => validateFields(this.requiredFields, state);
  validationMessage = () =>
    getValidationMessage(this.requiredFields, this.state);

  extractFields = () => {
    // Fields are all text inputs indicated by ending in the word "Value"
    const fields = Object.keys(this.state)
      .filter(key => key.endsWith('Value'))
      .reduce(
        (result, key) =>
          Object.assign(result, {
            [key.replace('Value', '')]: this.state[key],
          }),
        {},
      );

    if (this.fieldNames.includes('relatedItems')) {
      fields.relatedItems = this.state.relatedItems.join(',');
    }

    return fields;
  };

  submit = () => {
    this.props.submitForm(
      { fields: this.extractFields(), images: this.state.images },
      this.state,
    );
  };

  getFooterProps = (submitOverride, submitDisabled, submitDisabledMessage) => {
    const firstPage = this.state.stage === 1;
    const lastPage = this.state.stage === this.pages;

    return {
      submitText: lastPage
        ? TEXT.COMMON_LABELS.submitText
        : TEXT.COMMON_LABELS.nextText,
      submitOnClick: lastPage ? submitOverride || this.submit : this.nextPage,
      submitDisabled:
        lastPage &&
        (submitDisabled !== undefined ? submitDisabled : !this.state.formValid),
      submitDisabledMessage:
        lastPage &&
        (submitDisabledMessage !== undefined
          ? submitDisabledMessage
          : this.validationMessage(this.state)),
      cancelText: firstPage
        ? TEXT.COMMON_LABELS.cancelText
        : TEXT.COMMON_LABELS.backText,
      cancelOnClick: firstPage ? this.props.closeForm : this.backPage,
    };
  };

  nextPage = () => this.setState(state => ({ stage: state.stage + 1 }));
  backPage = () => this.setState(state => ({ stage: state.stage - 1 }));
}



// WEBPACK FOOTER //
// ./src/components/contribution-form/form-components/form-controller/index.js